import { useLiteSiteStore } from "../store";

export function useOnBusinessPlan() {
  const business = useLiteSiteStore(({ business }) => business);
  return business?.plan === "business";
}
